var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/Guard.ts
var isNull = (value) => {
  return typeof value === "object" && value === null;
};
var isUndefined = (value) => {
  return typeof value === "undefined";
};
var isBigInt = (value) => {
  return typeof value === "bigint";
};
var isString = (value) => {
  return typeof value === "string";
};
var isNumber = (value) => {
  return typeof value === "number";
};
var isBoolean = (value) => {
  return typeof value === "boolean";
};
var isArray = (value) => {
  return !!value && typeof value === "object" && Array.isArray(value);
};
var isPrimitive = (value) => {
  if (!value) {
    return false;
  }
  return [isUndefined, isBoolean, isNumber, isString, isBigInt].some((validate) => validate(value));
};
var isObject = (value) => {
  if (isArray(value) || isPrimitive(value)) {
    return false;
  }
  return typeof value === "object";
};
var isEmpty = (value) => {
  if (!value) {
    return false;
  }
  if (isArray(value)) {
    return value.length === 0;
  }
  if (isObject(value)) {
    return Object.keys(value).length === 0;
  }
  return !value;
};

export {
  __export,
  isNull,
  isUndefined,
  isBigInt,
  isString,
  isNumber,
  isBoolean,
  isArray,
  isPrimitive,
  isObject,
  isEmpty
};
//# sourceMappingURL=chunk-GX7V4YTP.js.map